export const animateSliderImage = (
  tl: gsap.core.Timeline,
  sliderDarkImg: HTMLElement,
  sliderLightImg: HTMLElement,
  nextReversed: boolean,
) => {
  // dark -> ight: dark exits right, light enters from left
  // light -> dark: light exits left, dark enters from right

  const exitX = nextReversed ? '100%' : '-100%';
  const enterX = nextReversed ? '-100%' : '100%';

  const outImg = nextReversed ? sliderDarkImg : sliderLightImg;
  const inImg = nextReversed ? sliderLightImg : sliderDarkImg;

  tl.to(outImg, {x: exitX, duration: 0.8, ease: 'power3.out'}, 0).fromTo(
    inImg,
    {x: enterX},
    {x: '0%', duration: 0.8, ease: 'power3.out'},
    0,
  );
};
